import React from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import {makeStyles, Typography} from "@material-ui/core";
import VS from "constants/ValidationShema";
import SingleButton from "components/popup/components/SingleButton";
import TextInput from "components/TextInput";
import DoubleButton from "components/popup/components/DoubleButton";
import Select from "components/Select";
import {streamPlatformLabel} from "../constants/OnlinePlatforms";
import RfxOfferService from "services/RfxOfferService";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    disabledEmpty: {
        fontStyle: 'italic'
    }
}));

function EditDescriptionPopup(
    {
        demandId,
        roundId,
        onClose = () => {
        },
        onUpdated = () => {
        },
        sessionOnlineStatus,
        formSubmit
    }) {

    const classes = useStyle();
    const formId = useId();

    const disabled = !sessionOnlineStatus.editable;
    const handleSubmit = () => formSubmit[formId]();

    const getTypeElements = () => {

        const elements = sessionOnlineStatus.streamPlatforms.map(x => ({
            label: streamPlatformLabel(x),
            value: x
        }))

        return [{label: Tr('streaming_not_share'), value: ""}, ...elements]
    }

    const onSubmit = ({platform, link}) => {
        RfxOfferService.saveOffersPublicSessionOnline(roundId, {platform, link: platform ? link : ""}).then(onUpdated)
    }
    return (
        <Dialog
            title={Tr('streaming_platform_form_title')}
            open={true}
            maxWidth={'sm'}
        >

            <Form
                initialValues={{
                    platform: sessionOnlineStatus.sessionOnline.platform,
                    link: sessionOnlineStatus.sessionOnline.link
                }}
                validationSchema={Yup.object().shape({
                    link: VS.stringMaxNoRq(2048)
                        .when('platform',
                            {
                                is: (val) => Boolean(val),
                                then: VS.string()
                            }
                        )
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>

                        <Select
                            id="platform"
                            formikProps={formikProps}
                            items={getTypeElements()}
                            label={Tr('streaming_platform')}
                        />

                        {Boolean(formikProps.values.platform) &&
                        <Typography dangerouslySetInnerHTML={{__html: Tr(`streaming_platform_description_${formikProps.values.platform}`)}}></Typography>}

                        {Boolean(formikProps.values.platform) &&
                        <TextInput
                            id='link'
                            formikProps={formikProps}
                            label={Tr(`streaming_platform_link_${formikProps.values.platform}`)}
                            disabled={disabled}
                        />
                        }


                        <div className={classes.actions}>
                            {disabled ?
                                <SingleButton
                                    justify='flex-end'
                                    label={Tr('close')}
                                    onClick={onClose}
                                />
                                :
                                <DoubleButton
                                    justify='flex-end'
                                    labelFirst={Tr('cancel')}
                                    labelSecond={Tr('confirm')}
                                    onClickFirst={onClose}
                                    onClickSecond={handleSubmit}
                                />}
                        </div>
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(EditDescriptionPopup);